// extracted by mini-css-extract-plugin
export default {"filtersBtn":"ButtonFilters_filtersBtn__J7678"};